var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu-item",class:{
    'menu-item--not-implemented': _vm.notImplemented
  },on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"menu-item__text"},[_vm._t("text")],2),_vm._v(" "),_c('div',{staticClass:"menu-item__icon"},[_vm._t("icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }